const { requestManager } = require('../../requestManager');

const { API_PATH } = require('../../config/config');

class PlaceMastaApi {
  /**
   * 利用施設取得
   * @param {Array<number>} rsvPlaceIds 予約可能施設IDs
   * @param {Array<number>} rsvTelPlaceIds 電話予約可能施設IDs
   * @return {Promise<Array>} 利用施設リスト
   */
  getUsePlaces = async (rsvPlaceIds, rsvTelPlaceIds) => {
    const params = { rsvPlaceIds, rsvTelPlaceIds };
    const result = await requestManager.post(`${API_PATH}/masta/place/r`, params);
    return result.data;
  };
}

export default new PlaceMastaApi();
